import React from 'react';
import CommonVehicleRegistrationDialog from '../common/VehicleRegistrationDialog';
import { PARTY_KIND } from '../../constants/partyKindLookupConstants';

const VehicleRecordRegistrationDialog = (props) => (
  <CommonVehicleRegistrationDialog {...props} partyType={PARTY_KIND.VEHICLE} />
);

export default VehicleRecordRegistrationDialog;
